import DoAPICall from './DoAPICall'

//Create user
export async function createUser(userToken, user){
    const apiPayload = {
        httpMethod:'post',
        userToken,
        uri:'users',
        payLoad:{
            client_id:user.client_id,
            fullnames:user.fullnames,
            username:user.username,
            password:user.password,
            group_id:user.group_id,
            mobileNumber:user.mobileNumber,
            revenueCollectorCode:user.revenueCollectorCode,
            status:user.status,
            email:user.email
        },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get All user
export async function getUsers(userToken){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'users',
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get All user
export async function getUsersOfClient(userToken,client_id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'usersofclient/'+client_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get One user
export async function getUser(userToken, id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'users/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get One user
export async function getCurrentUser(userToken){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'users/currentuser',
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get Groups of the user
export async function getGroupsOfUser(userToken, id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'groupsofuser/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}


//Get Rights of the User
export async function getRightsOfUser(userToken){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'rightsofuser',
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update user
export async function updateUser(userToken, user){
    const apiPayload = {
        httpMethod:'put',
        userToken,
        uri:'users/'+user.id,
        payLoad:{
                username:user.username,
                email:user.email,
                mobileNumber:user.mobileNumber,
                revenueCollectorCode:user.revenueCollectorCode,
                fullnames:user.fullnames,
                status:user.status
            },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Update user
export async function changePassword(userToken, user){
    const apiPayload = {
        httpMethod:'put',
        userToken,
        uri:'users/'+user.id,
        payLoad:{
                password:user.password
            },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Delete user
export async function deleteUser(userToken, id){
    const apiPayload = {
        httpMethod:'delete',
        userToken,
        uri:'users/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}